<!-- Panel Overlay -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 print:hidden"
  (click)="close()"
></div>

<!-- Right Side Panel - 50% Width -->
<div
  class="fixed top-0 right-0 h-full w-1/2 min-w-[400px] max-w-[600px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto print:hidden"
  [class.translate-x-0]="isOpen"
  [class.translate-x-full]="!isOpen"
>
  <!-- Panel Header -->
  <div
    class="flex items-center justify-between pb-2 border-b border-gray-200 bg-blue-500 mb-3 px-4 py-3"
  >
    <h2 class="text-2xl text-white font-semibold">Import Data</h2>
    <button mat-icon-button class="btnClose" (click)="close()" [disabled]="isImporting" matTooltip="Close (ESC)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Panel Content -->
  <div class="space-y-4 px-4 py-2">
    <!-- Source Selection -->
    <div class="mb-3">
      <h3 class="text-lg font-semibold text-gray-800 mb-2">Import From</h3>

      <!-- Tenant Selection -->
      <div class="mb-3">
        <mat-checkbox
          [(ngModel)]="filterByTenant"
          (change)="onTenantFilterChange()"
          [disabled]="isImporting"
          class="mb-2"
        >
          <span class="font-medium">Filter by Tenant</span>
        </mat-checkbox>

        <mat-form-field appearance="outline" class="w-full mt-2" *ngIf="filterByTenant">
          <mat-label>Select Tenant</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            type="text"
            matInput
            [formControl]="tenantControl"
            [matAutocomplete]="tenantAuto"
            placeholder="Search tenant..."
            [disabled]="isImporting"
          />
          <mat-autocomplete #tenantAuto="matAutocomplete" [displayWith]="displayTenantFn">
            <mat-option *ngFor="let tenant of filteredTenants$ | async" [value]="tenant">
              {{ tenant.tenantName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Store Selection -->
      <div class="mb-3">
        <mat-checkbox
          [(ngModel)]="filterByStore"
          (change)="onStoreFilterChange()"
          [disabled]="isImporting"
          class="mb-2"
        >
          <span class="font-medium">Filter by Store</span>
        </mat-checkbox>

        <mat-form-field appearance="outline" class="w-full mt-2" *ngIf="filterByStore">
          <mat-label>Select Store</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            type="text"
            matInput
            [formControl]="storeControl"
            [matAutocomplete]="storeAuto"
            placeholder="Search store..."
            [disabled]="isImporting"
          />
          <mat-autocomplete #storeAuto="matAutocomplete" [displayWith]="displayStoreFn">
            <mat-option *ngFor="let store of filteredStores$ | async" [value]="store">
              {{ store.storeName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- Masters Heading -->
    <div class="mb-3 border-t border-gray-200 pt-3">
      <h3 class="text-lg font-semibold text-gray-800 mb-1">Masters</h3>
      <p class="text-sm text-gray-600">Select the data you want to import</p>
    </div>

    <!-- Select All -->
    <div class="bg-gray-50 p-3 rounded-lg">
      <mat-checkbox
        [checked]="allSelected"
        [indeterminate]="someSelected"
        (change)="toggleSelectAll()"
        [disabled]="isImporting"
        class="font-medium"
      >
        Select All
      </mat-checkbox>
    </div>

    <!-- Masters List -->
    <div class="space-y-1">
      <div
        *ngFor="let master of masters"
        class="p-1.5 rounded-lg hover:bg-gray-50 transition-colors"
      >
        <mat-checkbox
          [checked]="master.selected"
          (change)="master.selected = !master.selected"
          [disabled]="isImporting"
        >
          {{ master.label }}
        </mat-checkbox>
      </div>
    </div>

    <!-- Progress Bar -->
    <div *ngIf="isImporting" class="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500">
      <p class="text-sm font-medium text-blue-700 mb-2">
        Importing data... {{ importProgress | number: '1.0-0' }}%
      </p>
      <mat-progress-bar
        mode="determinate"
        [value]="importProgress"
        class="h-2 rounded"
      ></mat-progress-bar>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-center items-center gap-3 pt-4 border-t border-gray-200">
      <button mat-stroked-button type="button" (click)="close()" [disabled]="isImporting">
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="importData()"
        [disabled]="!canImport"
        class="min-w-[140px]"
      >
        <mat-icon *ngIf="!isImporting" class="mr-2">download</mat-icon>
        <mat-icon *ngIf="isImporting" class="mr-2 animate-spin">sync</mat-icon>
        {{ isImporting ? 'Importing...' : 'Import Data' }}
      </button>
    </div>
  </div>
</div>
